import React from 'react';

import { SVGIcon } from 'UIKit/index';
import Analytics from 'Assets/images/AppLogo/analytics.svg';

const backgroundStyle = {
    backgroundImage: 'url(' + Analytics + ')',
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center',
};
export default function DCAnalytics(props) {
    return <SVGIcon {...props} viewBox="0 0 2000 2000" style={backgroundStyle} />;
}
